module.exports = __webpack_public_path__ + "img/phone-siemens.e46b39a8.webp";